import React, { ReactElement } from 'react';
import { Outlet, Navigate, useNavigation } from 'react-router-dom';
import { Loader } from 'common/components/Loader/Loader';
import { getFromLocalstorage } from 'common/utils/local-storage.utils';
import { EAuthFlagName } from 'domains/auth/constants/auth.constants';
import { ROUTES_MAPPING } from '../constants/route.constants';

const ProtectedRouteGuard = (): ReactElement => {
  const isAuth = getFromLocalstorage(EAuthFlagName);
  const { state } = useNavigation();

  return (
    <>
      {!isAuth ? <Navigate to={ROUTES_MAPPING.PUBLIC.LOGIN} /> : <Outlet />}
      {state === 'loading' && <Loader />}
    </>
  );
};

export default ProtectedRouteGuard;
